import getFriendImageURL from "./get_friend_image_URL";
import replaceTextInString from "../../../objects/CommonUse/replace_text_in_string";
import determineItemName from "./determine_item_name";
import PurchaseItemEventText from "../datasets/PurchaseItemEventText";
import eventImageDirOptions from "../datasets/event_image_dir_options";

export const determineWhichFriendToDisplay = (directoryName, friendList, friendInfo, currentCard, currentGameDate, 
         purchaseArr) => {
    let cardImageObj="";
    let searchString = "";
    let possibleFriendList = eventImageDirOptions.find(elem => elem.directoryName === directoryName).friendList;
    let newFriendList = [];
    for (let i=0; i<friendList.length; i++){
        if (friendList[i].introDate !== ""){
            if (possibleFriendList.includes(friendList[i].name)){
                newFriendList.push(friendList[i]);
            }
        }
    }
    let friendObj = getFriendImageURL(newFriendList, friendInfo, currentCard, currentGameDate);
    let imagePosition = "friend-position";
    let imageClass = "mx-auto d-block friend-game-img"
    let additionalInfo = {friendName: friendObj.friendName};
    let itemName = "";
    if (currentCard.description.includes("||purchaseEventDesc||")){
        itemName = determineItemName(purchaseArr);
        if (itemName !== ""){
               let textObj =  PurchaseItemEventText.find(elem => elem.itemName === itemName);
               if (textObj ){
                      additionalInfo = {...additionalInfo, string: textObj.descText};
                      searchString = "purchaseEventDesc";
               }
        }
 }
    currentCard.description = 
            replaceTextInString(currentCard.description, additionalInfo, searchString, "string");
     
    let cardImage = true;
    if (friendObj.friendName === "Your friend"){
        //  this means that no friend is found.  In such cases the card s/b displayed but not 
        //  the picture
        cardImage = false;
    }
    cardImageObj = { cardImageURL: friendObj.cardImageURL, imagePosition: imagePosition, imageClass: imageClass,
            friendName: friendObj.friendName, cardImage: cardImage, itemName: itemName};
               
    return cardImageObj;
   
}
export default determineWhichFriendToDisplay;

